// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__9DBY2","spinner":"Loading_spinner__roHxX","spinn":"Loading_spinn__MImN3"};